<style lang="less" scoped>
  .card-panel {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    &.wrong {
      background: rgba(255, 0, 0, .5);
    }
    &.correct {
      background: rgba(0, 0, 255, .4);
    }
  }
  .answer,
  .input {
    height: 50%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    img {
      width: 58px;
    }
  }
</style>

<template lang="pug">
  .card-panel(:class='{ wrong: !check, correct: check }')
    .answer
      img(:src='`/static/card_result/result-card-${answer.shape}-${answer.card}@2x.png`')
    .input
      img(
        v-if='input.card && input.shape'
        :src='`/static/card_result/${matched}-card-${input.shape}-${input.card}@2x.png`')
</template>

<script>
export default {
  props: {
    answer: {
      type: Object,
    },
    input: {},
  },
  computed: {
    matched() {
      let type = 'incorrect';
      if (this.check) {
        type = 'correct';
      }
      return type;
    },
    check() {
      let result = false;
      if (this.input.shape === this.answer.shape && this.input.card === this.answer.card) {
        result = true;
      }
      return result;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/card_result_panel.vue